import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IApiAdTargeting } from 'redux-state/advertisement/types.js';
import { ILayoutState } from 'redux-state/layout/types.js';
import { IPageConfig } from './types.page.js';

export const reduxInitialStateLayout = (): ILayoutState => ({
  screen: {
    layout: {
      type: 'layout',
      name: 'not-found',
      primary: {
        slots: {
          rightMinor: { modules: [] },
          rightMajor: { modules: [] },
          leftMinor: { modules: [] },
          main: { modules: [] },
          leftMajor: { modules: [] },
          first: { modules: [] },
        },
      },
      secondary: {
        slots: {
          right: { modules: [] },
          major: { modules: [] },
          minor: { modules: [] },
          bottom: { modules: [] },
          main: { modules: [] },
        },
      },
      last: {
        modules: [],
      },
    },
    advertising: {
      targeting: {
        staticData: [] as IApiAdTargeting[],
      },
    },
    metadata: {},
    type: 'screen',
  },
  pageLoaded: false,
  pageTimestamp: 0,
});

export type LayoutAction = PayloadAction<{ screen?: IPageConfig; overlay?: IPageConfig; timestamp: number }>;

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: reduxInitialStateLayout(),
  reducers: {
    REDUX_LAYOUT_SET: (
      state,
      action: PayloadAction<{ screen?: IPageConfig; overlay?: IPageConfig; timestamp: number }>,
    ) => {
      const { screen, overlay, timestamp } = action.payload;
      return {
        ...state,
        screen: screen ?? reduxInitialStateLayout().screen,
        overlay,
        pageTimestamp: timestamp,
      };
    },
    REDUX_LAYOUT_CLEAR_OVERLAY: (state) => {
      return {
        ...state,
        overlay: undefined,
      };
    },
    REDUX_LAYOUT_RESET: () => {
      return {
        ...reduxInitialStateLayout(),
        overlay: undefined,
        pageTimestamp: Date.now(),
      };
    },
  },
});

export const { REDUX_LAYOUT_SET, REDUX_LAYOUT_CLEAR_OVERLAY, REDUX_LAYOUT_RESET } = layoutSlice.actions;

export const layoutReducer = layoutSlice.reducer;
